import { render } from "./DailySummaryReportDetails.vue?vue&type=template&id=4979fb8e"
import script from "./DailySummaryReportDetails.vue?vue&type=script&lang=js"
export * from "./DailySummaryReportDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__